import { type JSX } from 'react';
import { Link } from 'react-router-dom';
import { MailOpen } from 'lucide-react';

/**
 * Something is addressed to you (FB-0021), said in the shell so it reaches whoever lands
 * wherever. The dashboard panel could not: a client-only account is redirected to its own
 * case before that panel renders, so a practice's invitation to join as a tutor lived only
 * in the email it was sent in.
 */
export function PendingActionsBanner({ count }: { count: number }): JSX.Element {
  return (
    <div
      role="status"
      data-testid="pending-actions-banner"
      className="flex flex-wrap items-center justify-between gap-3 border-b border-primary/30 bg-primary/10 px-4 py-2 text-sm text-foreground"
    >
      <div className="flex items-center gap-2">
        <MailOpen className="h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
        <span>
          {count === 1
            ? 'You have an invitation or agreement waiting for you.'
            : `You have ${String(count)} invitations or agreements waiting for you.`}
        </span>
      </div>
      <Link
        to="/pending"
        data-testid="pending-actions-banner-link"
        className="font-medium text-primary hover:underline"
      >
        Open
      </Link>
    </div>
  );
}
